var React = require('react');

function ALogoPrimary (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"st2","d":"M 166.6 464 L 242 222 L 182 42 L 30.9 464 Z M 335.3 464 L 193 40 H 308 L 460.5 464 Z"}));
}

ALogoPrimary.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 500 500","style":{"enableBackground":"new 0 0 500 500"},"xmlSpace":"preserve"};

module.exports = ALogoPrimary;

ALogoPrimary.default = ALogoPrimary;
